import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "../../View.css";
import "../../Grid.css";
import "../../Form.css";
import "../../App.css";
import SearchView from "../../widgets/SearchView";
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';
import QualificationSearchForm from './QualificationSearchForm';

const utils = new ViewUtils();

const headCells = [
    { id: "Description", numeric: false, disablePadding: true, label: "Qualification Name" }
]

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'info', label: '', tooltip: 'Select Qualification from the table and click save to add', icon: 'InfoIcon' }
            ]
        }
    ]
}

class Qualification extends Component {

    constructor(props) {
        super(props);

        this.state = {
            model: {
                QualificationName: ""
            },
            keyUpSwitch: false,
        }

        this.searchParameters = [
            { Name: "QualificationName", Value: "" }
        ]
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            e.preventDefault();
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={this.props.showTitle === true || utils.isNull(this.props.showTitle) ? 'Qualification' : null}>
                <SearchView
                    config={toolbarConfig}
                    mode={this.props.mode}
                    headCells={headCells}
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/indicium/BursaryApplication/GetBursaryQualification"}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="Description"
                    checkRefreshToken={this.props.checkRefreshToken}
                    model={this.state.model}
                    searchParameters={this.searchParameters}
                    keyUpSwitch={this.state.keyUpSwitch}
                >
                    <QualificationSearchForm model={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}/>
                </SearchView>
            </ViewContainer>
        )
    }
}

export default withRouter(
    connect()(Qualification)
);